// components/ui/cn.ts
// Minimal class-name joiner for the UI primitives (UI Phase 1).
// Deliberately not clsx/tailwind-merge: variants here are designed not to
// collide, and keeping the kit dependency-free keeps the bundle lean.

export type ClassValue = string | false | null | undefined;

export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ');
}
